import { useState } from "react";
import { message } from "antd";
import CopyInput from "V2.0/common/CopyInput";
import { deleteInstagramConfig } from "./service";
import { Button } from "V2.0/common/button";
import { Badge } from "V2.0/common/badge";

import InstagramLogo from "V2.0/images/instagram.png";
import { showErrorToast } from "V2.0/utils";

function InstagramConnected({
  workspaceId,
  instagramConfiguration,
  fetchInstagramConfiguration,
  isViewOnly,
}) {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data) => {
    setLoading(true);
    message.loading("Disconnecting");

    try {
      const response = await deleteInstagramConfig({ workspaceId });

      if (response.status === 200) {
        message.destroy();
        message.success("Instagram disconnected");
        fetchInstagramConfiguration(workspaceId);
        setLoading(false);
      }
    } catch (ex) {
      setLoading(false);
      message.destroy();
      showErrorToast(ex, "Failed to disconnect Instagram");
      return;
    }
  };

  return (
    <div>
      <div className="flex flex-col items-center">
        <div className="w-full max-w-md p-8 border rounded-lg">
          <div className="flex gap-x-2 mb-4">
            <img
              src={InstagramLogo}
              width={24}
            />
            <h3 className="text-base font-semibold leading-6 text-gray-900">
              Instagram
            </h3>
            <Badge color="emerald">Connected</Badge>
          </div>
          <div className="flex flex-col gap-y-8">
            <div className="mt-5">
              <CopyInput
                value="https://api.apivoicecall.com/api/instagram/webhook"
                title="Instagram Webhook URL"
                type="password"
                disabled
              />
            </div>

            <div className="">
              <CopyInput
                value="4915359cede4b64cb190f02bc1b396af"
                title="Verify token"
                type="password"
                disabled
              />
            </div>
            <div className="">
              <CopyInput
                value={instagramConfiguration?.instagramToken}
                title="Instagram token"
              />
            </div>
            <div className="">
              <CopyInput
                value={instagramConfiguration?.pageID}
                title="Page ID"
              />
            </div>

            {!isViewOnly && (
              <Button
                loading={loading}
                onClick={handleSubmit}
              >
                Disconnect Instagram
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default InstagramConnected;
